import React from "react";
import { MdLink, MdSend, MdMoreVert } from "react-icons/md";

import { PreviewLayout } from ".";
import { QRProps } from "@/contexts/QREditorContext/types";
import { Divider } from "../Divider";
import { useTranslation } from "react-i18next";

export default function PreviewEmail(props: QRProps<"email">) {
  const { email, subject, message } = props?.data ?? { email: "", message: "", subject: "" };
  const isInitPreview = props?.initPreview;
  const { t } = useTranslation();

  return (
    <>
      <div className="preview-email__header">
        <div className="preview-email__header-title">{t("preview_email_text_label")}</div>
        <div className="preview-email__header-icons">
          <MdLink size={24} />
          <MdSend size={24} />
          <MdMoreVert size={24} />
        </div>
      </div>
      <PreviewLayout
        page="email"
        dataQA="preview-email-container"
        isInitPreview={isInitPreview}
      >
        <div className="preview-email__container">
          <div className="preview-email__row">
            <div className="preview-email__label">{t("preview_address_text_label")}</div>
            <div className="preview-email__email">{email}</div>
          </div>

          <Divider spacing={0} />

          <div className="preview-email__row">
            <div className="preview-email__label">{t("preview_subject_text_label")}</div>
            <div className="preview-email__subject">{subject}</div>
          </div>

          <Divider spacing={0} />

          <div className="preview-email__column">
            <div className="preview-email__label">{t("preview_message_text_label")}</div>
            <div className="preview-email__message">{message}</div>
          </div>
        </div>
      </PreviewLayout>
    </>
  );
}
